import {
  IonPopover,
  IonContent,
  IonButton,
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonItem,
  IonLabel,
} from "@ionic/react";
import { useRef } from "react";

interface QueryInfoPopoverProps {
  queryInfo: any;
  translations: Record<string, string>;
  triggerId?: string;
}

const QueryInfoPopover: React.FC<QueryInfoPopoverProps> = ({
  queryInfo,
  translations,
  triggerId,
}) => {
  const modal = useRef<HTMLIonModalElement>(null);

  if (!queryInfo) return null;

  return (
    <IonPopover trigger={triggerId} triggerAction="click">
      <IonContent className="ion-padding">
        <IonButton fill="clear" id={`${triggerId}-open-modal`} expand="block">
          {translations["lbl_query_info"] || "Query Info"}
        </IonButton>
        <IonModal
          ref={modal}
          trigger={`${triggerId}-open-modal`}
          backdropDismiss={true}
        >
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonButton onClick={() => modal.current?.dismiss()}>
                  {translations["lbl_btn_close"] || "Close"}
                </IonButton>
              </IonButtons>
              <IonTitle>
                {translations["lbl_query_info"] || "Query Info"}
              </IonTitle>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonItem>
              <IonLabel>
                <h2>Query Name:</h2>
                <p>{queryInfo.queryDetails.queryName}</p>
              </IonLabel>
            </IonItem>
            <IonItem>
              <IonLabel>
                <h2>Query Details:</h2>
                <p>
                  {Object.values(queryInfo.queryDetails)
                    .map((v) => `"${v}"`)
                    .join(", ")}
                </p>
              </IonLabel>
            </IonItem>
            <IonItem>
              <IonLabel>
                <h2>SQL Text:</h2>
                <p style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                  {queryInfo.sqlText}
                </p>
              </IonLabel>
            </IonItem>
            <IonItem>
              <IonLabel>
                <h2>SQL Parameters:</h2>
                {queryInfo.sqlParameter.map((p: any) => (
                  <p key={p.name}>
                    {p.name} : {p.value}
                  </p>
                ))}
              </IonLabel>
            </IonItem>
          </IonContent>
        </IonModal>
      </IonContent>
    </IonPopover>
  );
};

export default QueryInfoPopover;
